// The outcome of one environment-image build. The empty string is its own state: an
// instance that has never attempted a build has no outcome to report, which is not the
// same as a build that failed.
export enum ImageBuildStatus {
    None      = '',
    Building  = 'building',
    Succeeded = 'succeeded',
    Failed    = 'failed',
    Skipped   = 'skipped',
}

// The steps of one build, in the order the plane walks them. They arrive as keys rather
// than sentences, so the progress card reads in the user's own language.
export enum ImageBuildStep {
    CreateInstance = 'create_instance',
    InstallTools   = 'install_tools',
    PushInputs     = 'push_inputs',
    Build          = 'build',
    Pull           = 'pull',
    Import         = 'import',
    SmokeTest      = 'smoke_test',
    Verify         = 'verify',
    Swap           = 'swap',
    Cleanup        = 'cleanup',
}
